export default __webpack_public_path__ + "static/media/closet5-after1-768w.3fa13d02.webp";